import axios from 'axios';

import { MainUrl } from "../constants"

const API_URL = `${MainUrl}/type_shift`


export const OpentypeShiftGet = async (token) => {
  try{
    const response = await axios.get(`${API_URL}/`, {
    headers: {
      Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error){
    if (error.status == 401){
      localStorage.removeItem('token');
      localStorage.removeItem('access_level');
      window.location.href = '/';
    }
  }
  
};


export const GetTypeShift = async (token, typeShiftId) => {
  const response = await axios.get(`${API_URL}/${typeShiftId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

